import { useEffect, useState } from "react";

const DEADLINE_KEY = "ax_academy_founding_deadline";

const WINDOW_MS = 1000 * 60 * 60 * 72;

const getDeadline = () => {
  let deadline = parseInt(localStorage.getItem(DEADLINE_KEY), 10);
  if (!deadline || deadline <= Date.now()) {
    deadline = Date.now() + WINDOW_MS;
    localStorage.setItem(DEADLINE_KEY, deadline);
  }
  return deadline;
};

const pad = (n) => String(n).padStart(2, "0");

export const CountdownTimer = ({ className = "" }) => {
  const [timeLeft, setTimeLeft] = useState({ h: 0, m: 0, s: 0 });

  useEffect(() => {
    let deadline = getDeadline();
    const tick = () => {
      let diff = deadline - Date.now();
      if (diff <= 0) {
        deadline = getDeadline();
        diff = deadline - Date.now();
      }
      setTimeLeft({
        h: Math.floor(diff / 3600000),
        m: Math.floor((diff % 3600000) / 60000),
        s: Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="countdown-timer-display">
      {[["HRS", timeLeft.h], ["MIN", timeLeft.m], ["SEC", timeLeft.s]].map(([label, val]) => (
        <div key={label} className="flex flex-col items-center bg-white/5 border border-rose-500/30 rounded-lg px-3 py-2 min-w-[56px]">
          <span className="font-mono text-xl font-bold text-white">{pad(val)}</span>
          <span className="font-mono text-[10px] tracking-widest text-rose-400">{label}</span>
        </div>
      ))}
    </div>
  );
};
